var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"align-items-stretch"},[_c('badge'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"all-messages"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_vm._v(" All Messages ")])])])])
}]

export { render, staticRenderFns }